import config from 'app-config'
import request from 'sb-request'
import { reducers } from 'redux/core'
import { getGqlQuery } from 'common/helpers'


const fetchCarouselProducts = () => {
  const testProductIds = {
    fragrance: [ 1160, 2042, 1053, 575 ],
    skincare: [ 785, 1179, 2554, 2385 ],
    makeup: [ 2349, 2583, 1646, 1649 ],
    wellness: [ 2099, 1203, 907, 912 ],
  }

  const prodProductIds = {
    fragrance: [ 872, 991, 825, 575 ],
    skincare: [ 802, 749, 1243, 1245 ],
    makeup: [ 1020, 1202, 1021, 1022 ],
    wellness: [ 1014, 1104, 980, 880 ],
  }

  const productIds = config.runEnv !== 'prod' ? testProductIds : prodProductIds

  const query = Object.keys(productIds).map((productType) => {
    const productsQuery = getGqlQuery('products', {
      includeProducts: productIds[productType],
    })

    return `${productType}: ${productsQuery} {
      id
      img
      name
      brand
      rating
      upchargePrice
    }`
  }).join()

  return request.post('graphql?name=thankYouPageProductsCarousel', {
    body: {
      query: `{
        ${query}
      }`,
    },
  })
    .then((result) => reducers.view.thankYouPage.setCarouselProducts(result))
}

const { setPaymentData, resetPaymentData } = reducers.view.thankYouPage

export default {
  setPaymentData,
  resetPaymentData,
  fetchCarouselProducts,
}
